import React from 'react';

import {MegaHeaderModuleProps} from "../models/mega-header-module.props";
import {ACTION_TYPES} from "../../../../../core/consts";
import {MegaHeaderModuleLogo} from "./mega-header-module.logo";
import {APP} from "../../../../../core/app/consts";
import {observer} from "mobx-react";
import styles from "../styles/mega-header-mobile.module.scss";
import classNames from "classnames";
import {NavigationTabsModuleAsync} from "../../../../../modules/navigation-tabs-module/components/navigation-tabs-module.async";

export class MegaHeaderModuleMobileProps extends MegaHeaderModuleProps {
}

export const MegaHeaderModuleMobile = observer(({controller}: MegaHeaderModuleMobileProps) => {
  const {state, device} = controller;
  const {headerModel, currentLinkModel, refreshLinkModel, selectedEntity} = state;

  const {entityVM, id} = headerModel || {};

  const logoProps = {
    entity: state.selectedEntity,
    iconContainerClassName: styles.icon_container,
    iconClassName: styles.icon,
    eager: true,
    device,
    model: refreshLinkModel,
    onClick: () => onEntityClick(),
    className: styles.logo_link,
    alt: state?.selectedEntity?.name
  };

  const onEntityClick = () => {
    controller.action(ACTION_TYPES.entityClick, {
      entityId: id,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[entityVM?.objectType],
      source: APP.ANALYTICS.SOURCES[currentLinkModel?.name],
      currentLinkModel: currentLinkModel?.name,
      sportTypeId: entityVM?.sport.id
    });

    return true;
  };

  return (
    <div className={styles.entity_container}>
      <div className={styles.icon_name_container}>
        <div className={classNames(styles.logo_link)}>
          {
            headerModel ? <MegaHeaderModuleLogo {...logoProps} /> : <div className={styles.icon_container}/>
          }
        </div>
      </div>
      {
        selectedEntity ? <NavigationTabsModuleAsync entity={selectedEntity} /> : null
      }
    </div>
  );
});

